import { LANGUAGE_CODES } from "./constants";

const getLanguageCode = (language: string, languageCodeOrId: string) => {
  switch (language) {
    case "fa":
      if (languageCodeOrId === "AF") return "fa-AF";
      break;
    case "zh":
      if (languageCodeOrId === "TW") return "zh-TW";
      break;
    case "fr":
      if (languageCodeOrId === "CA") return "fr-CA";
      break;
    case "pt":
      if (languageCodeOrId === "PT") return "pt-PT";
      break;
    case "es":
      if (languageCodeOrId === "MX") return "es-MX";
      break;
    default:
      if (LANGUAGE_CODES[language]) return language;

      return "not-found";
  }
  return language;
};

export default getLanguageCode;
